import * as React from "react";
import { getMobileProducts } from "@/api/products";
import { Filter, HandsetDeal } from "@/types/index";

const dataFilterValues: Array<Filter> = [
	{
		name: "1GB +",
		value: 1000,
		isChecked: false,
	},
	{
		name: "2GB +",
		value: 2000,
		isChecked: false,
	},
	{
		name: "3GB +",
		value: 3000,
		isChecked: false,
	},
	{
		name: "4GB +",
		value: 4000,
		isChecked: false,
	},
	{
		name: "5GB +",
		value: 5000,
		isChecked: false,
	},
	{
		name: "10GB +",
		value: 10000,
		isChecked: false,
	},
	{
		name: "20GB +",
		value: 20000,
		isChecked: false,
	},
	{
		name: "Unlimited",
		value: 999999999,
		isChecked: false,
	},
];

const networkFilterValues: Array<Filter> = [
	{
		name: "Vodafone",
		value: "Vodafone",
		isChecked: false,
	},
	{
		name: "Three",
		value: "Three",
		isChecked: false,
	},
	{
		name: "O2",
		value: "O2",
		isChecked: false,
	},
	{
		name: "Virgin",
		value: "Virgin",
		isChecked: false,
	},
	{
		name: "GiffGaff",
		value: "GiffGaff",
		isChecked: false,
	},
];

const contractFilterValues: Array<Filter> = [
	{
		name: "Rolling",
		value: 1,
		isChecked: false,
	},
	{
		name: "12 Months",
		value: 12,
		isChecked: false,
	},
	{
		name: "24 Months",
		value: 24,
		isChecked: false,
	},
	{
		name: "36 Months",
		value: 36,
		isChecked: false,
	},
];

const monthlyFilterValues: Array<Filter> = [
	{
		name: "Up to £10",
		value: 10,
		isChecked: false,
	},
	{
		name: "Up to £20",
		value: 20,
		isChecked: false,
	},
	{
		name: "Up to £30",
		value: 30,
		isChecked: false,
	},
	{
		name: "Up to £40",
		value: 40,
		isChecked: false,
	},
];

const brandsFilterValues: Array<Filter> = [
	{
		name: "Apple",
		value: "apple",
		isChecked: false,
	},
	{
		name: "Google",
		value: "google",
		isChecked: false,
	},
	{
		name: "Samsung",
		value: "samsung",
		isChecked: false,
	},

	{
		name: "Oppo",
		value: "oppo",
		isChecked: false,
	},
	{
		name: "Sony",
		value: "sony",
		isChecked: false,
	},
];

const upFrontCostFilterValues: Array<Filter> = [
	{
		name: "£0",
		value: 0,
		isChecked: false,
	},
	{
		name: "Up to £50",
		value: 50,
		isChecked: false,
	},
	{
		name: "Up to £100",
		value: 100,
		isChecked: false,
	},
	{
		name: "Up to £150",
		value: 150,
		isChecked: false,
	},
	{
		name: "Up to £200",
		value: 200,
		isChecked: false,
	},
];

const minutesFilterValues: Array<Filter> = [
	{
		name: "300 +",
		value: 299,
		isChecked: false,
	},
	{
		name: "600 +",
		value: 599,
		isChecked: false,
	},
	{
		name: "900 +",
		value: 899,
		isChecked: false,
	},
	{
		name: "Unlimited",
		value: 999999999,
		isChecked: false,
	},
];

const useMobileComparison = (
	manufacturer?: string,
	productName?: string,
	productModel?: string,
	simOnly?: boolean,
	upfrontCost?: number,
	contractLength?: number,
	dataAllowance?: number
) => {
	const [page, setPage] = React.useState<number>(1);
	const [sorter, setSorter] = React.useState<string>("");
	const [loading, setLoading] = React.useState<boolean>(false);
	const [selectedColour, setSelectedColour] = React.useState<string>("");
	const [products, setProducts] = React.useState<Array<HandsetDeal>>([]);
	const [selectedStorage, setSelectedStorage] = React.useState<string>("");
	const [hasNextPage, setHasNextPage] = React.useState<boolean>(false);

	const [networkFilters, setNetworkFilters] =
		React.useState<Array<Filter>>(networkFilterValues);
	const [minutesFilters, setMinutesFilters] =
		React.useState<Array<Filter>>(minutesFilterValues);
	const [monthlyFilters, setMonthlyFilters] =
		React.useState<Array<Filter>>(monthlyFilterValues);

	const [dataFilters, setDataFilters] =
		React.useState<Array<Filter>>(dataFilterValues);
	const [contractFilters, setContractFilters] =
		React.useState<Array<Filter>>(contractFilterValues);
	const [upFrontCostFilters, setUpFrontCostFilters] = React.useState<
		Array<Filter>
	>(upFrontCostFilterValues);
	const [brandsFilters, setBrandsFilters] =
		React.useState<Array<Filter>>(brandsFilterValues);

	React.useEffect(() => {
		setLoading(true);

		const filterToArrString = (filters: Array<Filter>) => {
			return filters.filter((f) => f.isChecked).map((f) => f.value);
		};

		const filteredBrands = () => {
			if (manufacturer) {
				return [...filterToArrString(brandsFilters), manufacturer ?? ""];
			}

			return filterToArrString(brandsFilters);
		};

		const filteredUpFrontCost = () => {
			if (upfrontCost !== undefined) {
				return [...filterToArrString(upFrontCostFilters), upfrontCost ?? 0];
			}

			return filterToArrString(upFrontCostFilters);
		};

		const filteredContractLength = () => {
			if (contractLength) {
				return [...filterToArrString(contractFilters), contractLength ?? 0];
			}

			return filterToArrString(contractFilters);
		};

		const filteredDataLength = () => {
			if (dataAllowance) {
				return [...filterToArrString(dataFilters), dataAllowance ?? 0];
			}

			return filterToArrString(dataFilters);
		};

		const productsRequest = async () => {
			const productResponse = await getMobileProducts(
				filteredBrands(),
				filterToArrString(networkFilters),
				filterToArrString(monthlyFilters),
				filteredUpFrontCost(),
				filteredDataLength(),
				filterToArrString(minutesFilters),
				filteredContractLength(),
				sorter,
				page,
				selectedColour,
				selectedStorage,
				productName,
				productModel,
				simOnly
			);

			if (page == 1) {
				setProducts([...(productResponse.data?.data ?? [])]);
				setHasNextPage(productResponse.data?.links.next ? true : false);
			} else {
				setProducts([...products, ...(productResponse.data?.data ?? [])]);
				setHasNextPage(productResponse.data?.links.next ? true : false);
			}
		};

		productsRequest().then(() => setLoading(false));
	}, [
		brandsFilters,
		networkFilters,
		monthlyFilters,
		upFrontCostFilters,
		dataFilters,
		minutesFilters,
		contractFilters,
		sorter,
		selectedColour,
		selectedStorage,
		manufacturer,
		productName,
		productModel,
		upfrontCost,
		contractLength,
		dataAllowance,
		page,
	]);

	const toggleDataFilter = (dataFilter: string | number) => {
		const newDataFilters = dataFilters.map((filter) => {
			if (filter.value.toString() === dataFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return { ...filter, isChecked: false };
		});
		setDataFilters(newDataFilters);
		setPage(1);
	};

	const toggleNetworkFilter = (networkFilter: string | number) => {
		const newNetworkFilters = networkFilters.map((filter) => {
			if (filter.value === networkFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return filter;
		});
		setNetworkFilters(newNetworkFilters);
		setPage(1);
	};

	const toggleContractFilter = (contractFilter: string | number) => {
		const newContractFilters = contractFilters.map((filter) => {
			if (filter.value.toString() === contractFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return filter;
		});
		setContractFilters(newContractFilters);
		setPage(1);
	};

	const toggleMinutesFilter = (minutesFilter: string | number) => {
		const newMinutesFilters = minutesFilters.map((filter) => {
			if (filter.value.toString() === minutesFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return { ...filter, isChecked: false };
		});
		setMinutesFilters(newMinutesFilters);
		setPage(1);
	};

	const toggleMonthlyFilter = (monthlyFilter: string | number) => {
		const newMonthlyFilters = monthlyFilters.map((filter) => {
			if (filter.value.toString() === monthlyFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return { ...filter, isChecked: false };
		});
		setMonthlyFilters(newMonthlyFilters);
		setPage(1);
	};

	const toggleBrandsFilter = (brandsFilter: string | number) => {
		const newBrandsFilters = brandsFilters.map((filter) => {
			if (filter.value.toString() === brandsFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return filter;
		});
		setBrandsFilters(newBrandsFilters);
		setPage(1);
	};

	const toggleUpFrontCostFilter = (upFrontCostFilter: string | number) => {
		const newUpFrontCostFilters = upFrontCostFilters.map((filter) => {
			if (filter.value.toString() === upFrontCostFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return { ...filter, isChecked: false };
		});
		setUpFrontCostFilters(newUpFrontCostFilters);
		setPage(1);
	};

	const clearFilters = () => {
		setDataFilters(dataFilterValues);
		setNetworkFilters(networkFilterValues);
		setContractFilters(contractFilterValues);
		setMinutesFilters(minutesFilterValues);
		setMonthlyFilters(monthlyFilterValues);
		setBrandsFilters(brandsFilterValues);
		setUpFrontCostFilters(upFrontCostFilterValues);
		setPage(1);
	};

	const resetPhone = () => {
		setSelectedStorage("");
		setSelectedColour("");
	};

	return {
		page,
		setPage,
		sorter,
		setSorter,
		selectedColour,
		setSelectedColour,
		products,
		setProducts,
		selectedStorage,
		setSelectedStorage,
		loading,
		setLoading,
		dataFilters,
		toggleDataFilter,
		networkFilters,
		toggleNetworkFilter,
		contractFilters,
		toggleContractFilter,
		minutesFilters,
		toggleMinutesFilter,
		monthlyFilters,
		toggleMonthlyFilter,
		brandsFilters,
		toggleBrandsFilter,
		upFrontCostFilters,
		toggleUpFrontCostFilter,
		clearFilters,
		resetPhone,
		hasNextPage,
		setHasNextPage,
	};
};

export default useMobileComparison;
